const angular = require('angular');
const app = angular.module('learn-resources');
/**
 * Videos Resource
 * @argument {$resource} $resource injected to define a resource api
 * @argument {Application} Application injected to gain access to the global Application functions and properties
 */
app.factory('Videos', ['$resource', 'appConfiguration', function ($resource, appConfiguration) {
  
  return $resource(appConfiguration.apiUrl + '/learn/v3/media/:subresource/:action/:videoId', null, {
    find: {params: {subresource: '', type: 'video'}, method: 'GET', isArray: true},
    get: {params: {videoId: ''}, method: 'GET', isArray: false},
    count: {params: {subresource: 'count', type: 'video'}, method: 'GET', isArray: false},
    create: {params: {subresource: 'videos'}, method: 'POST', isArray: false},
    update: {params: {subresource: ''}, method: 'POST', isArray: false},
    duplicate: {params: {subresource: '', action: 'duplicate'}, method: 'POST', isArray: false},
    remove: {params: {subresource: '', type: 'video'}, method: 'DELETE', isArray: false}
  });

}]);
